import type { StaticImageData } from "next/image";
import Image from "next/image";
import { useState } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { RxCross1 } from "react-icons/rx";

import { ExternalLink } from "@sorcery/ui";

import { useModal } from "~/providers/ModalProvider";
import { allCardsPath } from "~/utils/paths";

export const CardGalleryModal = ({
  index,
  cards,
}: {
  index: number;
  cards: StaticImageData[];
}) => {
  const { closeModal } = useModal();
  const [i, setI] = useState(index);

  return (
    <>
      <div className="mx-auto flex w-fit flex-col items-center justify-between duration-1000 animate-in fade-in">
        <Image
          key={i}
          placeholder="blur"
          className="m-4 duration-1000 animate-in fade-in"
          height={500}
          width={500}
          alt={""}
          priority
          // biome-ignore lint/style/noNonNullAssertion: <explanation>
          src={cards[i]!}
        />
        <div className="flex select-none flex-row justify-between">
          <AiOutlineArrowLeft
            className="m-2 cursor-pointer text-4xl text-white"
            onClick={() => setI(cards[i - 1] ? i - 1 : cards.length - 1)}
          />
          <RxCross1
            className="m-2 mx-6 cursor-pointer text-4xl text-white"
            onClick={() => closeModal()}
          />
          <AiOutlineArrowRight
            className="m-2 cursor-pointer text-4xl text-white"
            onClick={() => setI(cards[i + 1] ? i + 1 : 0)}
          />
        </div>
        <ExternalLink
          className="mt-2 text-lg text-white outline-none transition-all hover:underline"
          color="primary"
          href={allCardsPath}
          target="_blank"
        >
          See full card library
        </ExternalLink>
      </div>
    </>
  );
};
